import DashboardsViewer from './DashboardsViewer';
export default DashboardsViewer;
